<template>
  <div id="app">
    <div class="container">
      <Header v-if="isShow && !isRed"/>
      <HeaderRed v-if="isShow && isRed"/>
      <router-view v-on:handleShow="handleShow" v-on:handleRed="handleRed" />
<!--      <Footer v-if="isShowFooter"/>-->
    </div>
  </div>
</template>

<script>
  import Footer from "./components/Footer";
  import Header from "./components/Header";
  import HeaderRed from "./components/HeaderRed";
  import {mapMutations} from "vuex";
  import {ajaxGet, ajaxPost} from "./utils/ajax";

  export default {
    name: 'App',
    components: {Header, Footer,HeaderRed},
    data() {
      return {
        isShow: true,
        isShowFooter:true,
        isRed: false,
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      },
    },
    created() {
      //在页面加载时读取sessionStorage里的状态信息
      if (localStorage.getItem("store") ) {
        this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(localStorage.getItem("store"))));
      }
      //在页面刷新之前将vuex里的信息保存到sessionStorage里
      window.addEventListener("beforeunload",()=>{
        localStorage.setItem("store",JSON.stringify(this.$store.state));
      });
    },
    beforeMount(){

    },
    mounted() {},
    methods: {
      handleRed(bool) {
        this.isRed = bool;
      },
      handleShow(bool) {
        this.isShow = bool;
        this.isShowFooter =  bool;
      },
    },
  }
</script>

<style lang="scss">
  @import "style/theme.scss";
  #app {font-family: 'Avenir', Helvetica, Arial, sans-serif;-webkit-font-smoothing: antialiased;-moz-osx-font-smoothing: grayscale;color: #2c3e50;background-color: #fff;}
  /*滚动条*/
  ::-webkit-scrollbar {width: 6px;height:6px;background-color: #d8d8d8;border-radius:10px;}
  ::-webkit-scrollbar-track {border-radius:10px;}/* 滚动槽 */
  ::-webkit-scrollbar-thumb {border-radius: 10px;-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);background-color: rgba(0,0,0,0.1);}
  .container {width:100%; @include common-height;}
  /* 去除百度地图标志 */
  .BMap_cpyCtrl {display: none;}
  .anchorBL {display: none;}
  @media screen and (max-width: 750px) {
    ::-webkit-scrollbar {width: 0;}
  }
</style>



// WEBPACK FOOTER //
// src/App.vue